import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  tableHeaderCell: {
    borderBottom: `1px solid ${theme.palette.secondary.light} !important`,
    backgroundColor: "transparent !important",
    color: `${theme.palette.text.tertiary} !important`,
    width: "16.6%",
    fontFamily: "Poppins !important",
  },
  tableCell: {
    borderBottom: `1px solid ${theme.palette.secondary.light} !important`,
    backgroundColor: "transparent !important",
    color: `${theme.palette.text.primary} !important`,
    width: "16.6%",
    fontFamily: "Poppins !important",
  },
  avatarWithName: {
    border: `2px solid ${theme.palette.text.tertiary}`,
    display: "flex",
    alignItems: "center",
    gap: "5px",
    borderRadius: "25px",
    padding: "1px 7px 1px 0px",
  },
  card: {
    backgroundColor: "#1B1D28",
    borderRadius: "20px",
    minWidth: "600px",
  },
  contents: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  flexBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  logoDiv: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  urlAndButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    margin: "10px 0px",
  },
  checkBox: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginLeft: "20px",
  },
  title: {
    color: theme.palette.text,
    marginTop: "6px",
    padding: "0%",
    fontSize: "1rem",
    fontWeight: "600",
  },
  container: {
    width: "425px",
    borderRadius: "10px",
    backgroundColor: theme.palette.secondary.light,
    padding: "12px 18px 18px 18px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  actionContainer: {
    display: "flex",
    alignItem: "center",
    justifyContent: "flex-end",
    gap: "10px",
  },
  submitBtn: {
    borderRadius: "100px",
    backgroundColor: theme.palette.secondary.main,
    padding: "4px 8px",
  },
  clearBtn: {
    borderRadius: "100px",
    border: `1px solid ${theme.palette.text.tertiary}`,
    padding: "4px 10px",
  },
  textField: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px 10px",
    borderRadius: "10px",
  },

  //modal styles
  tab: {
    borderRadius: "10px 10px 0px 0px",
    backgroundColor: theme.palette.secondary.light,
    marginBottom: "-2px",
    padding: "0% !important",
    minHeight: "45px",
    marginRight: "8px",
    fontSize: "1rem",
    color: theme.palette.text.tertiary,
    border: `3px solid ${theme.palette.secondary.light}`,
    padding: "0px 12px 0px 12px",
  },
  tabsContainer: {
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
  },
  selectedTab: {
    // border: `3px solid ${theme.palette.secondary.dark}`,
    borderRadius: "10px 10px 0px 0px",
    backgroundColor: theme.palette.secondary.main,
    marginBottom: "-2px",
    padding: "0% !important",
    minHeight: "43px",
    marginRight: "8px",
    fontSize: "1rem",
    // borderBottom: `3px solid red`,
    padding: "0px 12px 0px 12px",
    zIndex: "999",
  },
  tabs: {
    minHeight: "45px",
    maxHeight: "45px",
    padding: "0% !important",
    borderBottom: `3px solid ${theme.palette.secondary.dark}`,
  },
  clearButton: {
    border: `2px solid ${theme.palette.secondary.main}`,
    width: "100px",
    borderRadius: "10px",
  },
  saveButton: {
    backgroundColor: theme.palette.secondary.main,
    width: "200px",
    borderRadius: "10px",
  },
}));
export default useStyles;
